import { jsx as C } from "react/jsx-runtime";
import { SvgIcon as e } from "../SvgIcon.js";
const r = (o) => /* @__PURE__ */ C(e, { ...o, children: /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0593 2.93211C20.9623 6.83516 20.9623 13.1632 17.0593 17.0663C13.1562 20.9693 6.82814 20.9693 2.92509 17.0663C-0.977959 13.1632 -0.977959 6.83516 2.92509 2.93211C6.82814 -0.97094 13.1562 -0.97094 17.0593 2.93211ZM9.39173 10.2356L12.5046 7.0913L13.2701 7.87187L9.39173 11.7968L6.94955 9.32253L7.71501 8.54933L9.39173 10.2356ZM5.60089 5H14.4C15.0051 5 15.5081 5.50074 15.5008 6.11193V12.7761V13.8881C15.5008 14.4993 15.0051 15 14.4 15H5.60089C4.99581 15 4.50008 14.4993 4.50008 13.8881V12.7761V6.11193C4.50008 5.50074 4.99581 5 5.60089 5ZM11.0976 12.7909H14.4V6.11193H5.60089V12.7909H8.896C8.896 13.4021 9.39173 13.9028 9.9968 13.9028C10.6019 13.9028 11.0976 13.4021 11.0976 12.7909Z"
  }
) });
export {
  r as Pass2
};
//# sourceMappingURL=Pass2.js.map
